module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dt-la-600.41d4c6ac11eb1381.png"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/dt-la-600.41d4c6ac11eb1381.png",width: 600,height: 450}],
        src: "https://static.sniffspot.com/packs/img/dt-la-600.41d4c6ac11eb1381.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dt-la-600.41d4c6ac11eb1381.png"},
        
        width: 600,
        height: 450
      }